// extracted by mini-css-extract-plugin
module.exports = {"viewports":"\"../../../../viewports.css\"","desktop":"1024px","image-upload-and-edit-container":"image-upload_image-upload-and-edit-container__2gyY3"};